import { lazy, useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { CountdownContext } from './context';
import useQueryString from './hooks/useQueryString';

const DefaultPages = lazy(() => import('./pages/default'));
const TheHyundaiPages = lazy(() => import('./pages/theHyundai'));
const HyunjunPages = lazy(() => import('./pages/hyunjun'));
const PlavePages = lazy(() => import('./pages/plave'));
const WayBackLovePages = lazy(() => import('./pages/wayBackLove'));
const TeachersPages = lazy(() => import('./pages/teachers'));
const JeongsewoonPages = lazy(() => import('./pages/jeongsewoon'));
const YooksungjaePages = lazy(() => import('./pages/yooksungjae'));
const LeejunyoungPages = lazy(() => import('./pages/leejunyoung'));

const tagManagerArgs = {
  gtmId: 'GTM-M27ZNVCH',
};

const App = () => {
  const { sessionId, expiredDate, collaboName } = useQueryString();

  const [countdown, setCountdown] = useState(
    expiredDate ? expiredDate - new Date() / 1000 : 0,
  );

  useEffect(() => {
    let countdownInterval;
    if (sessionId && expiredDate) {
      countdownInterval = setInterval(() => {
        const currTime = new Date() / 1000;
        setCountdown(expiredDate - currTime);
      }, 1000);
    }
    return () => {
      if (countdownInterval) {
        clearInterval(countdownInterval);
      }
    };
  }, [sessionId, expiredDate]);

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'prod') {
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  const router = () => {
    switch (collaboName.toUpperCase()) {
      case 'THE_HYUNDAI_AI':
        return <TheHyundaiPages />;
      case 'HYUNJUN':
        return <HyunjunPages />;
      case 'PLAVE':
        return <PlavePages />;
      case 'WAYBACKLOVE':
        return <WayBackLovePages />;
      case '티처스_미미미누':
      case '티처스_정승제':
      case '티처스_조정식':
        return <TeachersPages />;
      case '정세운':
      case '정세운_콘서트':
        return <JeongsewoonPages />;
      case '육성재':
        return <YooksungjaePages />;
      case '이준영':
        return <LeejunyoungPages />;
      default:
        return <DefaultPages />;
    }
  };

  return (
    <CountdownContext.Provider value={countdown}>
      {router()}
    </CountdownContext.Provider>
  );
};

export default App;
